export const config = {
  title: "TES Transportation",
  meta: {
    description:
      "TES Transportation provides executive black car and shuttle services in Nashville, TN. Specializing in airport transportation, corporate travel, weddings, and special events.",
    keywords: [
      "TES Transportation",
      "Nashville Car Service",
      "Nashville Airport Shuttle",
      "Black Car Service Nashville",
      "Corporate Transportation",
      "Wedding Transportation",
      "TES Executive Car Service"
    ],
    author: "TES Transportation",
    canonicalUrl: "https://testransportation.com/",
  },
  sections: {
    header: {
      businessName: "TES Transportation",
    },
    sectionB: {
      heroTitle: "TES Transportation",
      heroSubtitle: "Premier Black Car & Shuttle Services in Nashville, TN",
      learnAboutText: "View Our Services",
      phoneNumber: "6156503512",
      phoneLabel: "(615) 650-3512",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1695490825/photo/elegant-business-lady-in-minivan-taxi.jpg?s=612x612&w=0&k=20&c=TFzwlTxwr6ScrGs4Ed2XX4MiWsmSRIBNrzAagq0Vnz4=",
      cardData: [
        {
          title: "Executive Black Car",
          description: "Luxury black car transportation for corporate or personal travel.",
        },
        {
          title: "Airport Transfers",
          description: "Reliable, on-time pickup and drop-off to Nashville International Airport (BNA).",
        },
        {
          title: "Special Events & Weddings",
          description: "Professional service for weddings, concerts, and special occasions.",
        },
      ],
      description:
        "TES Transportation offers premier black car, shuttle, and executive chauffeur services in Nashville, TN. Whether you're heading to the airport, planning a wedding, or traveling for business, trust our professional team for safe, timely, and luxurious service.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Explore our full range of luxury and professional transportation services tailored to meet your travel needs.",
      cards: [
        {
          title: "Airport Transportation",
          description: "Pickups and drop-offs from BNA with real-time flight monitoring.",
          imageSrc: "https://media.istockphoto.com/id/1352121743/photo/elegant-female-passenger-getting-out-of-taxi.jpg?s=612x612&w=0&k=20&c=9HiUKQZwYWWlSw0NImTCvuvVYXixLO8gVnOXg01latM=",
          imageAlt: "Airport Transfer",
        },
        {
          title: "Corporate Travel",
          description: "Black car service for meetings, conferences, and VIP guests.",
          imageSrc: "https://media.istockphoto.com/id/1159638229/photo/senior-black-man-gets-in-taxi.jpg?s=612x612&w=0&k=20&c=2l-zyrpImLV8ArIQouJJcG00RF7JRXoaJNFyVHMQ9j0=",
          imageAlt: "Corporate Car Service",
        },
        {
          title: "Weddings & Events",
          description: "Luxury vehicles for weddings, proms, and private events.",
          imageSrc: "https://media.istockphoto.com/id/2170774181/photo/black-wedding-car-decorated-with-red-ribbons-chinese-traditional-wedding.jpg?s=612x612&w=0&k=20&c=iLSjiRpHycfJGvYhg-hLPnm2xVMYQIxvZV2GLp8k4Ic=",
          imageAlt: "Wedding Transportation",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Group Shuttles",
        "Private Chauffeur",
        "Night Out Transportation",
        "Hourly Rentals",
        "Concert & Sports Travel"
      ],
    },
    sectionD: {
      aboutTitle: "About TES Transportation",
      aboutImage: {
        src: "https://testransportation.com/wp-content/uploads/2025/06/MCP9Y11X_606285CB-5235-4BFF-A3DF-9E6FF51EC148-removebg-preview-e1753469353855.png",
        alt: "TES Transportation Fleet",
      },
      aboutText: [
        "TES Transportation has proudly served the greater Nashville area with top-tier transportation solutions for years.",
        "We specialize in black car service, executive travel, weddings, and more—backed by professional chauffeurs and luxury vehicles for a stress-free and comfortable ride."
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "TES Transportation Logo",
      businessName: "TES Transportation",
      contact: {
        phone: "6156503512",
        phoneLabel: "(615) 650-3512",
        email: "testransportations.nashville@gmail.com",
        website: "https://testransportation.com/",
        address: "Nashville, TN 37201, United States",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "Nashville, TN 37201, United States",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3307.2430102046884!2d-86.7816!3d36.1627!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88646656e8bb7c0b%3A0xabc1234567890!2sNashville%2C+TN%2C+USA!5e0!3m2!1sen!2sus!4v1710000000000!5m2!1sen!2sus",
    },
  },
};

export default config;
